import styled from 'styled-components';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background: rgba(150, 150, 150, .5);
  cursor: zoom-out;
`;

const Image = styled.img`
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: ${(props) => props.theme.shadows.dropdown};
  cursor: default;
`;

const Message = styled.div`
  padding: 24px 32px;
  border-radius: 12px;
  background: ${(props) => props.theme.colors.widget_background};
  color: ${(props) => props.theme.colors.inactive};
  box-shadow: ${(props) => props.theme.shadows.dropdown};
  cursor: default;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 24px;
  right: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: ${(props) => props.theme.colors.widget_background};
  color: ${(props) => props.theme.colors.text};
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.colors.main_cta};
    background: ${(props) => props.theme.colors.widget_hover_background};
    transition: all .2s ease-in;
  }
`;

export default {
  Wrapper, Image, Message, CloseButton,
};
